import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

/**
 * Encapsula toasts PrimeNG repetitivos (misma severidad, tiempos por defecto).
 * Debe declararse junto a `MessageService` en el mismo `providers` del módulo o componente.
 */
@Injectable()
export class AppNotificationService {
  constructor(private readonly messages: MessageService) {}

  add(opts: ToastMessageOptions): void {
    this.messages.add(opts);
  }

  success(summary: string, detail?: string, life = 4000): void {
    this.messages.add({ severity: 'success', summary, detail, life });
  }

  error(summary: string, detail?: string, life = 5000): void {
    this.messages.add({ severity: 'error', summary, detail, life });
  }

  warn(summary: string, detail?: string, life = 4000): void {
    this.messages.add({ severity: 'warn', summary, detail, life });
  }

  info(summary: string, detail?: string, life = 4000): void {
    this.messages.add({ severity: 'info', summary, detail, life });
  }
}
